export const environment = {
  isLocal: false,
  environmentType: 'dev',
  ridesCollection: 'dispatch/dev/read',
  emergenciesCollection: 'dispatch/dev/ride_emergencies',
  apiUrl: 'https://dev.dispatch-api.goadroit.com/v1/dispatch',
  adrAdminUrl: 'https://dev.admin.goadroit.com',
  production: false,
  partnerCollection: 'dev_partners',
  mapDetailsCollection: 'dispatch/dev/map_details',
  conversationsCollection: 'dev_conversations',
  rideMapZoomLevel: 13,
  cameraStatusesCollection: 'vehicles/dev/camera_status',
};
